import { initializeApp } from 'firebase/app';
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
const firebaseConfig = {
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN,
    projectId: FIREBASE_PROJECT_ID,
    storageBucket: FIREBASE_STORAGE_BUCKET,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
    appId: FIREBASE_APP_ID,
    measurementId: FIREBASE_MESSAGING_SENDER_ID,
};
const app = initializeApp(firebaseConfig);
export function getDatabase() {
    return getFirestore(app);
}
export function subscribe(path, observer, options = {}) {
    return onSnapshot(doc(getDatabase(), path), options, observer);
}
